import React, { Dispatch, FC, SetStateAction } from 'react';

import { PageTextContentType } from '../../../hooks/useContentMgmt';
import { JobQuoteModal } from '../confirm-cost/QuoteForm.rules';
import { FormState } from '../../../hooks/useFormState.types';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  Typography,
} from '@material-ui/core';
import { MultiFileUpload } from '../../pge-plus-common/multi-upload';
import { useTheme } from '@material-ui/core/styles';
import colors from '../../../themes/main-colors';
import UploadIcon from '../../pge-plus-common/static/uploadIcon.svg';
import { QuoteDocument } from '../../../__generated__/pgeplus-types';

interface Props {
  content: PageTextContentType;
  jobQuoteForm: FormState<JobQuoteModal>;
  setIsUploadingQuote: Dispatch<SetStateAction<boolean>>;
}

const UploadQuote: FC<Props> = ({
  content,
  jobQuoteForm,
  setIsUploadingQuote,
}: Props) => {
  const theme = useTheme();

  return (
    <Grid item xs={12}>
      <Typography css={{ margin: theme.spacing(0, 0, 4, 0) }}>
        {content.get('INSTALLER_QUOTE_TO_BE_UPLOADED')}
      </Typography>
      <MultiFileUpload
        form={jobQuoteForm}
        formField={'quoteDocuments'}
        uploadText={
          <Box
            style={{
              fontSize: 16,
              fontWeight: 'bold',
              lineHeight: '20px',
              color: colors.sparkBlue,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '26px',
            }}
          >
            <UploadIcon
              fontSize="large"
              css={{ verticalAlign: 'middle', display: 'block' }}
            />
            <Typography
              css={{
                display: 'block',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '16px',
              }}
              variant="subtitle1"
              component={'p'}
            >
              {content.get('UPLOAD_FILES')}
            </Typography>
          </Box>
        }
        setIsFileUploading={setIsUploadingQuote}
      />
      {jobQuoteForm.errors.quoteDocuments && (
        <FormHelperText error={true}>
          {jobQuoteForm.errors.quoteDocuments}
        </FormHelperText>
      )}
      <FormControlLabel
        control={
          <Checkbox
            checked={jobQuoteForm.values.confirmQuoteCopy}
            onChange={e =>
              jobQuoteForm.setValue('confirmQuoteCopy', e.target.checked)
            }
            color={'primary'}
          />
        }
        disabled={false}
        label={
          <Box>
            {content.get('QUOTE_FILE_UPLOAD_CONFIRM')}{' '}
            <Box component={'span'} css={{ color: colors.accentRed }}>
              *
            </Box>
          </Box>
        }
      />
      {jobQuoteForm.errors.confirmQuoteCopy && (
        <FormHelperText error={true}>
          {jobQuoteForm.errors.confirmQuoteCopy}
        </FormHelperText>
      )}
    </Grid>
  );
};

export default UploadQuote;
